'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _qs = require('qs');

var _qs2 = _interopRequireDefault(_qs);

var _routeMatcher = require('./route-matcher.js');

var _routeMatcher2 = _interopRequireDefault(_routeMatcher);

require('./find-index-polyfill');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function (window) {
    if (!window.routeHistory) {
        var documentTitle = document.title;

        var updateTitle = function updateTitle(title) {
            if (title && documentTitle) {
                document.title = documentTitle + ' - ' + title;
            } else if (title) {
                document.title = title;
            } else if (documentTitle) {
                document.title = documentTitle;
            }
        };

        var _base = '';

        var applyBase = function applyBase(pathname) {
            _base = pathname;
            refresh();
        };

        var findMatch = null;

        var applyRoutes = function applyRoutes(items) {
            findMatch = (0, _routeMatcher2.default)(items);
        };

        var middleware = [];

        var applyMiddleware = function applyMiddleware(items) {
            middleware.splice(0, middleware.length);

            items.forEach(function (item) {
                middleware.push(item);
            });
        };

        var runMiddleware = function runMiddleware(nextRoute, prevRoute) {
            return new Promise(function (resolve, reject) {
                var run = function run(index, runState) {
                    if (index < middleware.length) {
                        middleware[index]({
                            ok: function ok(state) {
                                run(index + 1, _extends({}, runState, state));
                            },
                            cancel: function cancel(state) {
                                resolve({ ok: false, state: state });
                            },
                            redirect: function redirect(pathname, state) {
                                resolve({ ok: false, redirect: pathname, state: state });
                            }
                        }, nextRoute, prevRoute);
                    } else {
                        resolve({ ok: true, state: runState });
                    }
                };

                run(0, {});
            });
        };

        var eventListeners = {};

        var addEventListener = function addEventListener(name, callback) {
            if (typeof name === 'string' && typeof callback === 'function') {
                name = name.toLowerCase();

                if (!eventListeners[name]) {
                    eventListeners[name] = [];
                }

                eventListeners[name].push(callback);
            }

            return function () {
                return removeEventListener(name, callback);
            };
        };

        var removeEventListener = function removeEventListener(name, callback) {
            if (typeof name === 'string' && typeof callback === 'function') {
                name = name.toLowerCase();

                if (eventListeners[name]) {
                    var index = eventListeners[name].findIndex(function (cb) {
                        return cb === callback;
                    });

                    if (index >= 0) {
                        eventListeners[name].splice(index, 1);
                    }
                }
            }
        };

        var callEventListeners = function callEventListeners(name, args) {
            if (typeof name === 'string') {
                name = name.toLowerCase();

                if (eventListeners[name]) {
                    eventListeners[name].forEach(function (eventListener) {
                        eventListener.apply(history, args);
                    });
                }
            }
        };

        var nextRouteId = 1;
        var routeHistory = [];

        var addRouteToHistory = function addRouteToHistory(id, pathname) {
            var index = routeHistory.findIndex(function (item) {
                return item.id === id;
            });

            if (index >= 0) {
                routeHistory.splice(index, routeHistory.length - index + 1);
            }

            routeHistory.push({
                id: id,
                pathname: pathname
            });
        };

        var reset = function reset() {
            nextRouteId = 1;
            routeHistory.splice(0, routeHistory.length);
        };

        var historyPushState = history.pushState;
        var pushState = function pushState(data) {
            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var id = nextRouteId++;

            if (_base && url) {
                url = '' + _base + url;
            }

            data = _extends({}, data, { __id: id });
            historyPushState.call(history, data, title || null, url || null);

            addRouteToHistory(id, url);

            return refresh();
        };
        history.pushState = pushState;

        var historyReplaceState = history.replaceState;
        var replaceState = function replaceState(data) {
            var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

            var id = nextRouteId++;

            if (_base && url) {
                url = '' + _base + url;
            }

            var oldUrl = window.location.pathname;
            var newUrl = url.split('?')[0];

            data = _extends({}, data, { __id: id });
            historyReplaceState.call(history, data, title || null, url || null);

            addRouteToHistory(id, url);
            if (oldUrl !== newUrl) {
                return refresh();
            } else {
                return Promise.resolve();
            }
        };
        history.replaceState = replaceState;

        var historyBack = history.back;
        var _back = function _back() {
            historyBack.call(history);

            return refresh();
        };
        history.back = _back;

        var historyForward = history.forward;
        var _forward = function _forward() {
            historyForward.call(history);

            return refresh();
        };
        history.forward = _forward;

        var historyGo = history.go;
        var _go = function _go(delta) {
            historyGo.call(history, delta);

            return refresh();
        };
        history.go = _go;

        var getRouteId = function getRouteId(state) {
            if (state && state.__id !== undefined) {
                return state.__id;
            } else {
                var routeId = nextRouteId++;
                history.replaceState({ __id: routeId });
                return routeId;
            }
        };

        var ignorePopState = false;
        window.onpopstate = function (event) {
            if (!ignorePopState) {
                nextRouteId = getRouteId(event.state) + 1;
                refresh();
            }
        };

        var isChanging = false;
        var activeRoute = { id: 0, pathname: '', state: {} };

        var refresh = function refresh() {
            var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            var pathname = _base ? location.pathname.substring(_base.length) : location.pathname;
            var search = location.search;
            var hash = location.hash;

            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    if (!isChanging) {
                        isChanging = true;
                        callEventListeners('changing');
                    }

                    var match = { item: null, params: {} };
                    if (typeof findMatch === 'function') {
                        match = findMatch(pathname);
                    }

                    var prevRoute = activeRoute;
                    var nextRoute = {
                        id: getRouteId(history.state),
                        pathname: pathname,
                        search: search,
                        query: _qs2.default.parse(search.substr(1)),
                        hash: hash.replace('#', ''),
                        match: match ? match.item : null,
                        state: _extends({}, history.state, { params: match ? match.params : null })
                    };

                    runMiddleware(nextRoute, prevRoute).then(function (result) {
                        if (result.ok) {
                            isChanging = false;
                            activeRoute = nextRoute;

                            activeRoute.state = _extends({}, activeRoute.state, result.state);

                            updateTitle(activeRoute.match ? activeRoute.match.title : activeRoute.title);

                            var action = force ? 'refresh' : 'none';
                            if (nextRoute.id > prevRoute.id) {
                                action = 'forward';
                            } else if (nextRoute.id < prevRoute.id) {
                                action = 'back';
                            } else if (nextRoute.pathname !== prevRoute.pathname) {
                                action = 'back';
                            }

                            resolve({ action: action, nextRoute: nextRoute, prevRoute: prevRoute });

                            callEventListeners('changed', [action, nextRoute, prevRoute]);
                        } else {
                            if (result.redirect) {
                                var redirectState = _extends({}, history.state, result.state);

                                history.replaceState(redirectState, null, result.redirect).then(function (redirectResult) {
                                    resolve(redirectResult);
                                });
                            } else if (nextRoute.id < prevRoute.id) {
                                ignorePopState = true;
                                historyForward.call(history);
                                setTimeout(function () {
                                    ignorePopState = false;
                                    resolve({ action: 'refresh', nextRoute: nextRoute, prevRoute: prevRoute });
                                }, 10);
                            } else if (routeHistory.length > 1) {
                                ignorePopState = true;
                                historyBack.call(history);
                                setTimeout(function () {
                                    ignorePopState = false;
                                    resolve({ action: 'refresh', nextRoute: nextRoute, prevRoute: prevRoute });
                                }, 10);
                            } else {
                                history.replaceState(history.state, null, '/').then(function (backResult) {
                                    resolve(backResult);
                                });
                            }
                        }
                    });
                }, 0);
            });
        };

        window.routeHistory = {
            push: function push(pathname, state) {
                return pushState(state, null, pathname);
            },
            replace: function replace(pathname, state) {
                return replaceState(state, null, pathname);
            },
            back: function back() {
                return _back();
            },
            forward: function forward() {
                return _forward();
            },
            go: function go(delta) {
                return _go(delta);
            },
            list: function list() {
                return [].concat(routeHistory);
            },
            base: function base() {
                return _base;
            },
            reset: reset,
            refresh: refresh,
            applyBase: applyBase,
            applyRoutes: applyRoutes,
            applyMiddleware: applyMiddleware,
            addEventListener: addEventListener,
            removeEventListener: removeEventListener
        };

        // replace the current history state
        history.replaceState({ __id: nextRouteId++ });
    }
})(window || global);

exports.default = window.routeHistory;
//# sourceMappingURL=route-history.js.map